// Phase H — BI / Reporting Dashboard API hooks.
// All endpoints are forwarder-internal only; the components consuming
// these hooks render an access-denied state when status === 403.
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Turn the dashboard's filter state into a query string. Drops empty /
// null entries so the request stays clean.
export const buildBIFilterParams = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v == null || v === "" || (Array.isArray(v) && v.length === 0)) return;
    if (Array.isArray(v)) p.set(k, v.join(","));
    else p.set(k, String(v));
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const useBIKpis = (filters) =>
  useQuery({
    queryKey: ["bi-kpis", filters],
    queryFn: () => axios.get(`${API}/bi/kpis${buildBIFilterParams(filters)}`).then((r) => r.data),
    staleTime: 30_000,
    keepPreviousData: true,
  });

export const useBITop = (filters, limit = 10) =>
  useQuery({
    queryKey: ["bi-top", filters, limit],
    queryFn: () => axios.get(`${API}/bi/top${buildBIFilterParams({ ...filters, limit })}`).then((r) => r.data),
    staleTime: 30_000,
    keepPreviousData: true,
  });

export const useBITrend = (filters) =>
  useQuery({
    queryKey: ["bi-trend", filters],
    queryFn: () => axios.get(`${API}/bi/trend${buildBIFilterParams(filters)}`).then((r) => r.data),
    staleTime: 30_000,
    keepPreviousData: true,
  });

export const useBIOperational = (filters) =>
  useQuery({
    queryKey: ["bi-operational", filters],
    queryFn: () => axios.get(`${API}/bi/operational${buildBIFilterParams(filters)}`).then((r) => r.data),
    staleTime: 30_000,
    keepPreviousData: true,
  });
